// extracted by mini-css-extract-plugin
export var chevronIcon = "_b4-2";
export var teamName = "_b4-1";
export var teamSwitcherButton = "_b4-0";